/**
 * 区域信息路由
 */
const YuchongRouter = {
  path: 'yuchong',
  name: 'Yuchong',
  meta: {
    requiresAuth: false,
    leftMenu: true // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Yuchong/index')
}
export default YuchongRouter
